import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';

import { ErrorBoundary } from './ui/ErrorBoundary.js';
import { listenForInstallPrompt } from './ui/onboarding/install.js';
import { availableTheme } from './ui/settings/availability.js';
import { applyTheme, readTheme } from './ui/theme.js';
import { App } from './ui/App.js';

import './ui/styles.css';

/**
 * Точка входа. Service Worker обновляется молча: спрашивать разрешения на
 * обновление личного трекера не у кого, а застрявшая старая версия — источник
 * расхождений между устройствами.
 */
registerSW({ immediate: true });

const root = document.getElementById('root');
if (root === null) throw new Error('нет узла #root');

// Тема ставится до первого кадра: иначе на старте мигает чужая палитра. Пока
// открыта только светлая, сохранённый выбор тёмной не применяется.
applyTheme(availableTheme(readTheme()));

// Приглашение установить приложение приходит один раз и рано — нередко до того,
// как React что-то нарисовал. Слушатель ставится до отрисовки, иначе кнопка
// «Установить» в подсказке новичку не появится никогда (3.16.10).
listenForInstallPrompt();

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
